export type GeckoDataPointsJSON = {
  name?: string
  unit?: string
  source?: string
  systems?: string[]
  description?: string
  measurement?: string
  indicator_id?: string
  indicator_type?: string
  instrument_tag?: string
  source_tag?: string
  point_source?: string
}
